import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_recommendations = _resolveComponent("project-recommendations")

  return (_openBlock(), _createBlock(_component_project_recommendations, {
    quantity: 12,
    "exclude-project-ids": [],
    "extra-large-screen-visible-items-count": $props.extraLargeScreenVisibleItemsCount,
    source: "backer-center"
  }, null, 8 /* PROPS */, ["extra-large-screen-visible-items-count"]))
}